import { render, staticRenderFns } from "./Medication.vue?vue&type=template&id=9b84855a&scoped=true"
import script from "./Medication.vue?vue&type=script&lang=js"
export * from "./Medication.vue?vue&type=script&lang=js"
import style0 from "./Medication.vue?vue&type=style&index=0&id=9b84855a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b84855a",
  null
  
)

export default component.exports